import React, { Component } from "react"
import {
  Input,
  Button,
  Icon,
  Affix,
  Menu,
  Row,
  DatePicker
} from "antd"
import { observer, inject } from "mobx-react"
import { action } from "mobx"
import { Link, withRouter } from "react-router-dom"
import moment from "moment"
import queryString from "query-string"

const RangePicker = DatePicker.RangePicker
const { Search } = Input

@inject("auth") @observer
class DataHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showDownloadModal: false,
      dayKey: "-1",
    }
  }

  // 搜索框更新
  @action
  changeSearch = (e) => {
    const keywords = e.target.value
    this.setState({
      inputSearch: keywords,
    })
  }
  searchData = () => {
    const { history, match } = this.props
    history.push({
      pathname: `${match.url}`,
      search: queryString.stringify({ keywords: this.state.inputSearch })
    })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  render() {
    const { inputSearch } = this.state
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          <div className="search-bar">
            <div className="pull-left">
              <Search
                value={inputSearch}
                placeholder="输入家系名搜索"
                size="large"
                onChange={this.changeSearch}
                onSearch={this.searchData}
              />
            </div>
            <div className="pull-right">
              <Link to="/jab/pgd/entrance">
                <Button type="primary">
                  <Icon type="plus" />添加新家系
                </Button>
              </Link>
            </div>
          </div>
          {this.renderDayMenu()}
        </div>
      </Affix>
    )
  }

  onDataChange = (e, type) => {
    this.props.store.list.tableData = []

    switch (type) {
      case "belong": this.onBelongChange(e)
        break
      case "app": this.onAppChange(e)
        break
      case "day": this.onDayChange(e)
        break
      default: this.dateChangeOk()
    }
  }

  dateChange = (dateValue, dateString) => {
    const { list: { updateQueryMap } } = this.props.store
    updateQueryMap({ start: dateString[0], end: dateString[1] })
    this.setState({     //日期回显
      dateValue: dateValue
    })
  }

  dateChangeOk = () => {
    this.setState({  // 重置近几天的选项
      dayKey: "-1",
    })
    let {
      list: { filterData, queryMap }
    } = this.props.store

    filterData({ end: moment(queryMap.end, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
  }

  onDayChange = (e) => {
    let startDay = null
    const {
      list: { filterData }
    } = this.props.store

    this.setState({  //设置近几天同时重置日期选择
      dayKey: e.key,
      dateValue: null,
    })
    if (e.key !== "-1") {
      startDay = moment(moment() - e.key * 1000 * 3600 * 24).format("YYYY-MM-DD")
    }

    filterData({ start: startDay, end: null })
  }

  renderDayMenu = () => {
    return (
      <Row
        type="flex"
        justify="start"
        align="middle"
        className="search-time-bar affix-line"
      >
        <Menu className="menu-day" onClick={e => this.onDataChange(e, "day")}
          selectedKeys={[this.state.dayKey]}
          mode="horizontal"
          key="menu_date_0">
          <Menu.Item key="-1">
            <Icon type="calendar" />全部
          </Menu.Item>
          <Menu.Item key="0">今天</Menu.Item>
          <Menu.Item key="3">三天内</Menu.Item>
          <Menu.Item key="7">七天内</Menu.Item>
          <Menu.Item key="15">十五天内</Menu.Item>
          <Menu.Item key="30">三十天内</Menu.Item>
        </Menu>
        <RangePicker
          ranges={{
            "今天": [moment(), moment()],
            "本月": [moment().startOf("month"), moment()]
          }}
          showTime
          value={this.state.dateValue}
          onChange={this.dateChange}
          onOk={this.onDataChange}
          disabledDate={this.disabledDate}
        />
      </Row>
    )
  }
}

export default withRouter(DataHeader)


// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/data_manage/containers/DataHeader.js